/* ============================================================
   VARELON — Bouton WhatsApp flottant (toutes les pages)
   ============================================================ */
(function () {
  if (!document.body) return;

  /* >>>>>> À PERSONNALISER <<<<<<
     Numéro au format international, sans + ni espaces ni zéro initial.
     Exemple : 06 12 34 56 78  ->  212612345678 */
  var NUMERO = '212689532112';
  var MESSAGE = 'Bonjour, je souhaite des informations sur une montre VARELON.';
  var TITRE = 'VARELON Accessories';
  var SOUS_TITRE = 'Réponse en quelques minutes';
  var ACCROCHE =
    'Bonjour 👋 Une question sur une montre, la livraison ou le paiement à la livraison ? Écrivez-nous.';
  var LIBELLE_BOUTON = 'Ouvrir la discussion';

  var lien =
    'https://wa.me/' + NUMERO + '?text=' + encodeURIComponent(MESSAGE);

  /* ---------- Panneau dépliant ---------- */
  var panneau = document.createElement('div');
  panneau.className = 'varelon-wa-panel';
  panneau.setAttribute('role', 'dialog');
  panneau.setAttribute('aria-label', 'Contact WhatsApp');
  panneau.hidden = true;
  panneau.innerHTML =
    '<div class="varelon-wa-panel__head">' +
    '<div class="varelon-wa-panel__avatar" aria-hidden="true">V</div>' +
    '<div class="varelon-wa-panel__id">' +
    '<strong>' + TITRE + '</strong>' +
    '<span>' + SOUS_TITRE + '</span>' +
    '</div>' +
    '<button type="button" class="varelon-wa-panel__close" aria-label="Fermer">&times;</button>' +
    '</div>' +
    '<div class="varelon-wa-panel__body">' +
    '<p class="varelon-wa-bulle">' + ACCROCHE + '</p>' +
    '</div>' +
    '<a class="varelon-wa-panel__cta" href="' + lien + '" target="_blank" rel="noopener noreferrer">' +
    LIBELLE_BOUTON +
    '</a>';

  /* ---------- Bouton rond ---------- */
  var bouton = document.createElement('button');
  bouton.type = 'button';
  bouton.className = 'varelon-wa-button';
  bouton.setAttribute('aria-label', 'Nous contacter sur WhatsApp');
  bouton.setAttribute('aria-expanded', 'false');
  bouton.innerHTML =
    '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-3.9-.9L3 20.5l1.6-4.9A8.4 8.4 0 0 1 12 3.1a8.4 8.4 0 0 1 9 8.4Z"/>' +
    '</svg>' +
    '<span class="varelon-wa-button__label">WhatsApp</span>';

  function ouvrir() {
    panneau.hidden = false;
    requestAnimationFrame(function () {
      panneau.classList.add('varelon-wa-panel--open');
    });
    bouton.setAttribute('aria-expanded', 'true');
    bouton.classList.add('varelon-wa-button--open');
  }

  function fermer() {
    panneau.classList.remove('varelon-wa-panel--open');
    bouton.setAttribute('aria-expanded', 'false');
    bouton.classList.remove('varelon-wa-button--open');
    setTimeout(function () {
      panneau.hidden = true;
    }, 250);
  }

  bouton.addEventListener('click', function () {
    if (panneau.hidden) {
      ouvrir();
    } else {
      fermer();
    }
  });

  panneau.querySelector('.varelon-wa-panel__close').addEventListener('click', fermer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panneau.hidden) fermer();
  });

  document.addEventListener('click', function (e) {
    if (panneau.hidden) return;
    if (panneau.contains(e.target) || bouton.contains(e.target)) return;
    fermer();
  });

  document.body.appendChild(panneau);
  document.body.appendChild(bouton);
})();
